// Contexts
import { useUploadIdContextConsumerHook } from 'containers/upload-id/contexts/upload-id.context';
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
// Event Handlers
import { UploadIdVerificationHandlers } from '../handlers/upload-id-verification.handlers';
import { UploadIdVerificationTrackingHandlers } from '../handlers/upload-id-verification.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { UploadIdVerificationHookType } from './types/upload-id-verification.hook.type';

const useUploadIdVerificationHook = (): UploadIdVerificationHookType => {
  const { setUploadIdState, verificationInformation } = useUploadIdContextConsumerHook(),
    { setError } = useFetchErrorContextConsumerHook(),
    { setCurrentState } = useAppContextConsumerHook(),
    { url } = verificationInformation || {};

  const { handleTrackWebSocketError } = useAppTrackingHook(UploadIdVerificationTrackingHandlers);

  return {
    ...UploadIdVerificationHandlers({
      handleTrackWebSocketError,
      setCurrentState,
      setError,
      setUploadIdState,
    }),
    url,
  };
};

export { useUploadIdVerificationHook };
